// Libraries
import { NgModule } from '@angular/core';

// Services
import { DialogService } from './../../services/dialog.service';
import { CanDeactivateGuard } from './can-leave.guard';

@NgModule({
  declarations: [
  ],
  exports: [
  ],
  imports: [
  ],
  providers: [
    DialogService,
    CanDeactivateGuard
  ]
})
export class CanLeaveModule {
}
